/**
 * Map institution API/user records ↔ InvestorInfo Formik field names.
 */

export function mapInvestorSeedFromApiUser(u) {
  if (!u) return {};
  return {
    entityName: u.entityName || u.institution_name || u.institutional_name || '',
    entityType: u.entityType || u.institution_type || u.institutional_type || '',
    foundedYear: u.foundedYear || u.institution_founded_year || u.institutional_founded_year || '',
    entityWebsite:
      u.entityWebsite || u.institution_website || u.institutional_website || '',
    entityAddress:
      u.entityAddress || u.institution_address || u.institutional_address || '',
    entityCity: u.entityCity || u.institution_city || u.institutional_city || '',
    entityState: u.entityState || u.institution_state || u.institutional_state || '',
    entityCountry:
      u.entityCountry || u.institution_country || u.institutional_country || '',
    entityPostalCode:
      u.entityPostalCode || u.institution_postal_code || u.institutional_postal_code || '',
    institutionAum: u.institutionAum || u.institutional_aum || u.institution_aum || '',
    typicalInvestmentSize:
      u.typicalInvestmentSize ||
      u.institutional_typical_investment_size ||
      u.institution_typical_investment_size ||
      '',
    communicationPreference:
      u.communicationPreference || u.institutional_communication_preference || '',
    decisionProcess: u.decisionProcess || u.institutional_decision_process || '',
    contactTitle: u.contactTitle || u.institution_title || u.institutional_title || '',
    institution_phone: u.institution_phone || u.investor_phone || '',
    entityDescription:
      u.entityDescription || u.institution_description || u.institutional_description || '',
    qualificationCategories: Array.isArray(u.qualificationCategories)
      ? u.qualificationCategories
      : Array.isArray(u.qualification_categories)
        ? u.qualification_categories
        : [],
  };
}

export function mapInstitutionEntityToInvestorForm(entity) {
  if (!entity) return {};
  return mapInvestorSeedFromApiUser(entity);
}

export function mapInvestorFormToEntityData(values, userId, email) {
  return {
    institution_name: values.entityName,
    institution_email: email,
    institution_website: values.entityWebsite || '',
    institution_type: values.entityType || '',
    institution_address: values.entityAddress || '',
    institution_city: values.entityCity || '',
    institution_state: values.entityState || '',
    institution_country: values.entityCountry || '',
    institution_postal_code: values.entityPostalCode || '',
    institution_founded_year: values.foundedYear || '',
    institution_aum: values.institutionAum || '',
    institution_typical_investment_size: values.typicalInvestmentSize || '',
    institution_communication_preference: values.communicationPreference || '',
    institution_decision_process: values.decisionProcess || '',
    institution_title: values.contactTitle || '',
    institution_description: values.entityDescription || '',
    institution_phone: values.institution_phone || '',
    qualification_categories: values.qualificationCategories || [],
    investor_id: userId,
    created_by: userId,
  };
}

export function mapInvestorFormToEntityUpdate(values) {
  return {
    institution_name: values.entityName,
    institution_website: values.entityWebsite || '',
    institution_type: values.entityType || '',
    institution_address: values.entityAddress || '',
    institution_city: values.entityCity || '',
    institution_state: values.entityState || '',
    institution_country: values.entityCountry || '',
    institution_postal_code: values.entityPostalCode || '',
    institution_founded_year: values.foundedYear || '',
    institution_aum: values.institutionAum || '',
    institution_typical_investment_size: values.typicalInvestmentSize || '',
    institution_communication_preference: values.communicationPreference || '',
    institution_decision_process: values.decisionProcess || '',
    institution_title: values.contactTitle || '',
    institution_description: values.entityDescription || '',
    institution_phone: values.institution_phone || '',
    qualification_categories: values.qualificationCategories || [],
  };
}
